<template>
    <b-container fluid>
        <!-- Fake to setup beer -->
        {{setupBeer}}

        <!-- Modal for missing shipping info when updating a beer -->
            <b-modal no-fade size="l" id="modal-errorshipping1" ok-only title="Missing Shipping/Delivery Info" ok-title="OK">
                Please enter shipping and delivery info for consumers from the main inventory page before allowing consumers 
            </b-modal>

        <!-- Add inventory Error -->
            <b-row>
            <b-col>
                <b-modal no-fade size="l" id="modal-adderror" title="Found some errors" 
                ok-title="OK" ok-only>
                    <template v-slot:default="{ hide }">
                        <div v-if="invalidName">Please check beer name</div>
                        <div v-if="invalidBrewer">Please check brewery name</div>
                        <div v-if="invalidDelivery">Please choose a delivery method</div>
                        <div v-if="invalidSize">Please enter at least one container</div>
                        <div v-if="invalidBarrel1Size">Please check Barrel1 size</div>
                        <div v-if="invalidBarrel2Size">Please check Barrel2 size</div>
                        <div v-if="invalidBottleSize">Please check Can size</div>
                        <div v-if="invalidCanSize">Please check Bottle size</div>
                        <div v-if="invalidCost">Please enter only numbers for cost</div>

                    </template>
                </b-modal>
            </b-col>
        </b-row>

        <!-- Modal for missing shipping info when updating a beer -->
            <b-modal no-fade size="l" id='modal-shippingerror' ok-only title="Missing Shipping/Delivery Info" ok-title="OK">
                Please enter shipping and delivery info for consumers before allowing consumers 
            </b-modal>

        <!----------------------------->
            <!-- Consumer Cost Error -->
            <!----------------------------->
            <b-row>
                <b-col>
                    <b-modal no-fade size="l" id="modal-consumercosterror" title="Found some errors" 
                    ok-title="OK" ok-only>
                            <template v-slot:default="{ hide }">
                                <div >If selling to consumers, please enter a cost for consumers. Enter only numbers</div>
                            </template>
                    </b-modal>
                </b-col>
            </b-row>

        <!--       DISTRIBUTOR  BREWERY   -->
        <b-row  v-if="userProfile.isbrewer==2" style="margin-top:10px">
            <b-col>
                <div v-if='invalidBrewer' class='inputwarning'>Please choose brewery</div>
                <b-dropdown style="margin-top:10px"  variant="primary"  size="lg"  id="dropbowndelselect" text="Select A Brewery">
                    <b-dropdown-item  v-for="(brewery) in distributorBreweries" :key="brewery.company" @click="setBrewery(brewery)">{{brewery.company}}</b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
        <b-row  v-if="userProfile.isbrewer==2" >
            <b-col><strong>{{beer.brewerName}}</strong></b-col>
        </b-row>
        
        <!-- Card for name, description, ABV -->
        <b-card style="background-color:#f2f2f2; margin-top:20px" :title='"More About This " + beer.type'>
        <!-- Name -->
        <b-row>
            <b-col>
                <div v-if='invalidName' class='inputwarning'>Please check name</div>
                <b-input-group prepend="Name" class="mt-3">
                    <b-form-input v-model="beer.beerName"></b-form-input>
                    <b-input-group-append>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>

        <!-- Description -->
        <b-row style="margin-top:20px">
            <b-col>
                <h5 style="">Description of this beverage</h5>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group
                    class="mb-0"
                    label-for="textarea-formatter"
                    description="Say something about this beverage">
                    <b-form-textarea
                        id="textarea-formatter"
                        v-model="beer.description"
                    ></b-form-textarea>
                </b-form-group>
                
            </b-col>
        </b-row>

        <!-- ABV -->
        <b-row>
            <b-col>
                <b-input-group prepend="(Optional) ABV %" class="mt-3">
                    <b-form-input v-model="beer.abv"></b-form-input>
                    <b-input-group-append>
                    </b-input-group-append>
                </b-input-group>
                
            </b-col>
        </b-row>
        </b-card>

        <!-- Delivery Method -->
        <b-card style="background-color:#f2f2f2; margin-top:10px">
        <b-row v-if="userProfile.isbrewer==1" style="margin-top:10px">
            <b-col>
                <div v-if='invalidDelivery' class='inputwarning'>Please choose delivery method</div>
                <b-dropdown variant='light' id="dropbowndelselect" text="Select A Distribution Method">
                    <b-dropdown-item  v-for="(deliveryAgent) in getDeliveryAgents" :key="deliveryAgent" @click="beer.deliveryMethod=deliveryAgent">{{deliveryAgent}}</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item-button  v-b-modal.modalmoremethods >Other</b-dropdown-item-button>
                </b-dropdown>
                    <b-modal no-fade id= "modalmoremethods"  title="Other delivery method" ok-only ok-title="OK"  @ok="beer.deliveryMethod=otherDeliveryMethod">
                    <b-form-group
                        class="mb-0"
                        label-for="textarea-formatter-delivery"
                        
                    >
                    <b-form-textarea
                        id="textarea-formatter-delivery"
                        v-model="otherDeliveryMethod"                    
                    ></b-form-textarea>
                </b-form-group>
                                    
                </b-modal>
            </b-col>
        </b-row>
        <b-row>
            <b-col><h5 style="margin-top:5px; padding-left:5px">{{theDeliveryMethod}}</h5></b-col>
        </b-row>
        </b-card>

        <!-- Containers -->
        <b-card style="background-color:#f2f2f2; margin-top:10px;" title="Containers and Prices">
        <b-row v-if="invalidSize" class='inputwarning'>
            <b-col>
                Please check valid sizes are entered
            </b-col>
        </b-row>

        <!-- Table for sizes and costs -->
        <table class="table table-bordered">
            <thead class="thead-dark">
                <tr>
                    <th scope="col"><small>Container</small></th>
                    <th scope="col"><small>Size</small></th>
                    <th scope="col"><small>Oz/(Can or Bottle)</small></th>
                    <th scope="col"><small>Available Quantity</small></th>
                    <th scope="col"><small>Price ($)</small></th>
                    <th v-if="userProfile.isbrewer==1&&allowConsumerSales" scope="col"><small>Sell to Consumers?</small></th>
                    <th  v-if="userProfile.isbrewer==1&&allowConsumerSales" scope="col"><small>Consumer Package Size</small></th>
                    <th  v-if="userProfile.isbrewer==1&&allowConsumerSales" scope="col"><small>Price for Consumers ($)</small></th>
                </tr>
            </thead>
            <tbody>
                <!-- Keg 1 -->
                <tr>
                    <td>Keg 1</td>
                    <td>
                        <b-form-select style="width:250px" size="sm" v-model="beer.barrel1Size" :options="barrelSizeOptions">
                            <template v-slot:first>
                                <!-- This is required to prevent bugs with Safari -->
                                <option disabled value="">Choose Keg 1 size</option>
                            </template>
                        </b-form-select>
                    </td>
                    <!-- Empty TD for can/case oz -->
                    <td>NA</td>
                    <td>
                        <b-form-input v-model="beer.barrel1Quantity"  size="sm"></b-form-input>
                    </td>
                    <td>
                        <b-form-input v-model="beer.barrel1Cost"  size="sm"></b-form-input>
                    </td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">
                        <b-form-checkbox id="checkbox-allowbarrel1" v-model="beer.consumerBarrel1" name="checkbox-allowbarrel1" :value=1 :unchecked-value=0>
                        </b-form-checkbox>
                    </td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">NA</td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">
                        <b-form-input  size="sm" v-model="beer.barrel1ConsumerCost" :disabled="!beer.consumerBarrel1"></b-form-input>
                    </td>
                </tr>

                <!-- Keg 2 -->
                <tr>
                    <td>Keg 2</td>
                    <td>
                        <b-form-select  size="sm" style="width:250px"  id='nested-barrelsize2' v-model="beer.barrel2Size" :options="barrelSizeOptions">
                                <template v-slot:first>
                                    <!-- This is required to prevent bugs with Safari -->
                                    <option disabled value="">Choose Keg 2 size</option>
                                </template>
                            </b-form-select>
                    </td>

                    <!-- Empty TD for can/case oz -->
                    <td>NA</td>
                    <td>
                        <b-form-input  size="sm" v-model="beer.barrel2Quantity" ></b-form-input>
                    </td>
                    <td>
                        <b-form-input size="sm"  v-model="beer.barrel2Cost" ></b-form-input>
                    </td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">
                        <b-form-checkbox id="checkbox-allowbarrel2" v-model="beer.consumerBarrel2" name="checkbox-allowbarrel2" :value=1 :unchecked-value=0>
                        </b-form-checkbox>
                    </td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">NA</td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">
                        <b-form-input size="sm" v-model="beer.barrel2ConsumerCost" :disabled="!beer.consumerBarrel2"></b-form-input>
                    </td>
                </tr>
                <!-- Cans -->
                <tr>
                    <td>Cans</td>
                    <td>
                        <b-input-group size="sm" prepend="Cans/Case" class="">
                            <b-form-input size="sm" v-model="beer.cansPerCase" ></b-form-input>
                        </b-input-group>
                    </td>
                    
                    <td>
                        <b-form-input size="sm" v-model="beer.ozPerCan" ></b-form-input>
                    </td>
                    <td>
                        <b-form-input size="sm" v-model="beer.canQuantity" ></b-form-input>
                    </td>
                    <td>
                        <b-form-input size="sm" v-model="beer.canCost" ></b-form-input>
                    </td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">
                        <b-form-checkbox id="checkbox-allowcan"  v-model="beer.consumerCan" name="checkbox-allowcan" :value=1 :unchecked-value=0>
                        </b-form-checkbox>
                    </td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">
                        <b-input-group size="sm" prepend="Cans" class="">
                            <b-form-input size="sm" v-model="beer.canConsumerCaseSize" :disabled="!beer.consumerCan" ></b-form-input>
                        </b-input-group>
                    </td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">
                        <b-form-input size="sm" v-model="beer.canConsumerCost" :disabled="!beer.consumerCan"></b-form-input>
                    </td>
                </tr>

                <!-- Bottles -->
                <tr>
                    <td>Bottles</td>
                    <td>
                        <b-input-group size="sm" prepend="Bottles/Case" class="">
                            <b-form-input size="sm" v-model="beer.bottlesPerCase" ></b-form-input>
                        </b-input-group>
                    </td>
                    
                    <td>
                        <b-form-input size="sm" v-model="beer.ozPerBottle" ></b-form-input>
                    </td>
                    <td>
                        <b-form-input size="sm" v-model="beer.bottleQuantity" ></b-form-input>
                    </td>
                    <td>
                        <b-form-input size="sm" v-model="beer.bottleCost" ></b-form-input>
                    </td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">
                        <b-form-checkbox id="checkbox-bottle" v-model="beer.consumerBottle" name="checkbox-bottle2" :value=1 :unchecked-value=0>
                        </b-form-checkbox>
                    </td>
                    <td v-if="userProfile.isbrewer==1&&allowConsumerSales">
                        <b-input-group size="sm" prepend="Bottles" class="">
                            <b-form-input size="sm" v-model="beer.bottleConsumerCaseSize" :disabled="!beer.consumerBottle"></b-form-input>
                        </b-input-group>
                    </td>
                    <td  v-if="userProfile.isbrewer==1&&allowConsumerSales">
                        <b-form-input  size="sm" v-model="beer.bottleConsumerCost" :disabled="!beer.consumerBottle"></b-form-input>
                    </td>
                </tr>
            </tbody>
        </table>
        <hr>

        </b-card>
        <!-- End Of New Size Inputs -->

        <!-- Logo -->
        <b-row>
            <b-col>
                
            </b-col>
        </b-row>


        <!-- Add beer -->
        <b-row style="margin-bottom:200px">
            <b-col>
                <div style="margin-top:20px; margin-bottom:20px">
                    <div v-if="showAddBeerError" class='inputwarning'> Please correct the errors above</div>
                    <b-button  size="lg" @click="addbeer" class="btn btn-success">Add This Beverage</b-button>

                    <transition name="fade">
                    <p v-if="showSuccess" class="success">Beer added</p>
                    </transition>
                </div>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
    import { mapState } from 'vuex'
    import { drinkCategories, mainBeerStylesList, wineCategories, fullBeerStylesList, deliveryAgents } from '../Myfunctions'
    const fb = require('../../firebaseConfig.js')
    export default {
        props: {
            theBeerFromType: Object
        },
        components: {
            },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'promotionsEnabled', 'distributorBreweries', 'allowConsumers', 'selectedDistBrewery']),

            setupBeer(){
                console.log("Got beer = ")
                console.log(this.theBeerFromType)
                this.beer.cat=this.theBeerFromType.cat
                this.beer.type=this.theBeerFromType.type
                this.beer.subType=this.theBeerFromType.subType
            },
            getDeliveryAgents(){
                var deliveryList = deliveryAgents
                return deliveryList
            },
            theDeliveryMethod(){
                if(this.beer.deliveryMethod) return this.beer.deliveryMethod
                else if(this.userProfile.isbrewer&&this.userProfile.deliveryMethod){
                    this.beer.deliveryMethod = this.userProfile.deliveryMethod
                    return this.userProfile.deliveryMethod
                }
                else return ""
            },
            
        },
        data() {
            return {
                beer:{
                    cat:'',
                    type:'',
                    subType:'',
                    beerName:'',
                    abv:'',
                    description:'',
                    quantity:'',
                    barrel1Size:'',
                    barrel1Quantity:'',
                    barrel1Cost:'',
                    barrel2Size:'',
                    barrel2Quantity:'',
                    barrel2Cost:'',
                    cansPerCase:'',
                    canQuantity:'',
                    ozPerCan:'',
                    ozPerBottle:'',
                    bottlesPerCase:'',
                    bottleQuantity:'',
                    canCost:'',
                    bottleCost:'',
                    multiSize:1,
                    deliveryMethod:'',  
                    brewerName:'',
                    brewerId:'',
                    logoFileThumbnailURL:'',
                    selectedDistroBrewer:{},
                    //Consumer info
                    allowConsumers:'0',
                    //Consumer delivery fees
                    consumerDeliveryCost:4.99,
                    //Kegseeker fees
                    kegseekerFees:4.99,
                    //Consumer delivery time
                    consumerDeliveryTime:2,
                    
                },
                showSuccess: false,
                showAddBeerError:false,
                otherDeliveryMethod:'',
                barrelSizeOptions: [
                    { value: null, text: 'None' },
                    { value: '1/2 Barrel, 15.5 Gal', text: '1/2 Barrel, 15.5 Gal'},
                    { value: '13.2 Gal, 50L', text: '13.2 Gal, 50L'},
                    { value: '1/4th Barrel, 7.75 Gal', text: '1/4th Barrel, 7.75 Gal'},
                    { value: '1/6th Barrel 5.16 Gal', text: '1/6th Barrel, 5.16 Gal'},
                    ],
                maxDescriptionLength:400,
                invalidName:false,
                invalidBrewer: false,
                invalidQuantity:false,
                invalidSize:false,
                invalidType:false,
                invalidCost:false,
                invalidABV:false,
                invalidDate:false,
                invalidContainer:false,
                invalidDelivery:false,
                invalidBarrel1Size : false,
                invalidBarrel2Size : false,
                invalidBottleSize : false,
                invalidCanSize : false,
                invalidDeliveryTime:false,
                invalidDeliveryFees:false,
                consumerDeliveryoptions: [
                    { text: 'Delivery', value: 'delivery' },
                    { text: 'Pickup (Free)', value: 'pickup' },
                    { text: 'Shipping' , value: 'shipping' },
                    ],
                consumerSizes: ['Barrel1', 'Barrel2', 'Cans', 'Bottles'
                    ],
                selectedConsumerDeliveryOptions:['delivery', 'pickup', 'shipping'],
                selectedConsumerSizes:[],
                shippingInfoError:false,
                allowConsumerSales:false,

                //Invalid Input Feedback
                barrel1QtyValid:true,
                barrel1PriceValid:true,
                barrel2QtyValid:true,
                barrel2PriceValid:true,
                canQtyValid:true,
                canPriceValid:true,
                cansPerCaseValid:true,
                ozPerCanValid:true,
                bottleQtyValid:true,
                bottlePriceValid:true,
                bottlesPerCaseValid:true,
                ozPerBottleValid:true,
                
            }
        },
        methods: {
            setDeliveryMethod(theMethod){
                this.beer.deliveryMethod=theMethod

            },
            setOtherDeliveryMethod(){
                this.beer.deliveryMethod = this.otherDeliveryMethod
            },
            setBrewery(brewery){
                this.selectedDistroBrewer = brewery
                this.beer.brewerName = brewery.company
                this.beer.brewerId = brewery.distbrewerid
                if (brewery.logoFileThumbnailURL) this.beer.logoFileThumbnailURL = brewery.logoFileThumbnailURL
                else this.beer.logoFileThumbnailURL = ''
            },
            addbeer(){
                var beerToAdd = {}
                //Set multi size always = 1
                beerToAdd.multiSize = 1

                var min=11111111111111111; 
                var max=99999999999999999;  
                this.invalidName=false
                this.invalidQuantity=false
                this.invalidSize=false
                this.invalidCost=false
                this.showAddBeerError=false
                this.invalidContainer = false
                var perCase = ''

                //Check for errors everywhere
                //Beer name
                if(!this.beer.beerName) this.invalidName = true
                else this.invalidName = false

                //Distributor brewery
                if(!this.beer.brewerName&&this.userProfile.isbrewer==2) this.invalidBrewer = true
                else this.invalidBrewer = false

                //Check beer sizes and that at least one has been entered
                var hasBarrels1 = 0
                var hasBarrels2 = 0
                var hasCans = 0
                var hasBottles = 0
                
                //CHECK IF ALL FIELDS HAVE BEEN ENTERED FOR A CONTAINER
                /**************************/
                /**** Check barrel1 ******/
                /**************************/
                if (this.beer.barrel1Size||this.beer.barrel1Cost||this.beer.barrel1Quantity){
                    if(!this.beer.barrel1Size||!this.beer.barrel1Cost||this.beer.barrel1Quantity<1||isNaN(this.beer.barrel1Quantity)){
                        this.invalidBarrel1Size = true
                        console.log("Invalid barrel1")
                    } 
                    else {
                        this.invalidBarrel1Size = false
                        hasBarrels1 = 1
                        beerToAdd.barrel1Size = this.beer.barrel1Size
                        if(isNaN(this.beer.barrel1Cost)) this.invalidCost=true
                        beerToAdd.barrel1Cost = this.beer.barrel1Cost
                        beerToAdd.barrel1Quantity = parseInt(this.beer.barrel1Quantity)
                    }
                } 
                if (this.beer.barrel2Size||this.beer.barrel2Cost||this.beer.barrel2Quantity){
                    if(!this.beer.barrel2Size||!this.beer.barrel2Cost||this.beer.barrel2Quantity<1||isNaN(this.beer.barrel2Quantity)){
                        this.invalidBarrel2Size = true
                        console.log("Invalid barrel2")
                    } 
                    else{
                        this.invalidBarrel2Size = false
                        hasBarrels2 = 1                        
                        beerToAdd.barrel2Size = this.beer.barrel2Size
                        if(isNaN(this.beer.barrel2Cost)) this.invalidCost=true
                        beerToAdd.barrel2Cost = this.beer.barrel2Cost
                        beerToAdd.barrel2Quantity = parseInt(this.beer.barrel2Quantity)
                    }                   
                } 
                if (this.beer.ozPerCan||this.beer.canCost||this.beer.cansPerCase||this.beer.canQuantity){
                    if (!this.beer.ozPerCan||!this.beer.canCost||!this.beer.cansPerCase||this.beer.canQuantity<1||isNaN(this.beer.canQuantity)){
                        this.invalidCanSize = true
                        console.log("Invalid Can")
                    } 
                    else{
                        this.invalidCanSize  = false
                        hasCans = 1
                        beerToAdd.ozPerCan = this.beer.ozPerCan
                        if(isNaN(this.beer.canCost)) this.invalidCost=true
                        beerToAdd.canCost = this.beer.canCost
                        beerToAdd.cansPerCase = this.beer.cansPerCase
                        beerToAdd.canQuantity = parseInt(this.beer.canQuantity)
                    }                   
                } 
                if(this.beer.ozPerBottle||this.beer.bottleCost||this.beer.bottlesPerCase||this.beer.bottleQuantity){
                    if(!this.beer.ozPerBottle||!this.beer.bottleCost||!this.beer.bottlesPerCase||this.beer.bottleQuantity<1||isNaN(this.beer.bottleQuantity)){
                        this.invalidBottleSize = true
                        console.log("Invalid Bottle")
                    } 
                    else{
                        this.invalidBottleSize  = false
                        hasBottles = 1
                        beerToAdd.ozPerBottle = this.beer.ozPerBottle
                        if(isNaN(this.beer.bottleCost)) this.invalidCost=true
                        beerToAdd.bottleCost = this.beer.bottleCost
                        beerToAdd.bottlesPerCase = this.beer.bottlesPerCase
                        beerToAdd.bottleQuantity = parseInt(this.beer.bottleQuantity)
                    }    
                }

                //Check of any of the sizes were entered incorrectly
                if(this.invalidBarrel1Size||this.invalidBarrel2Size||this.invalidBottleSize||this.invalidCanSize) this.invalidSize = true
                else this.invalidSize = false
                console.log("Invalid1 = " + this.invalidSize)
                //Check if at least one container was entered
                if(!hasBarrels1&&!hasBarrels2&&!hasCans&&!hasBottles) this.invalidSize = true
                else this.invalidSize = false
                console.log("Invalid2 = " + this.invalidSize)

                //Check delivery method
                var thedeliveryMethod = ''
                //Distribution method = self for distributors
                if (this.userProfile.isbrewer==1){
                    if(this.beer.deliveryMethod) thedeliveryMethod = this.beer.deliveryMethod
                } 
                if (this.userProfile.isbrewer==2){
                    thedeliveryMethod = this.userProfile.company

                }

                /**************************/
                //Check consumers
                /**************************/

                /* Check if userProfile has shipping info entered */
                var consumerShippingError = false
                if (this.beer.consumerBarrel1||this.beer.consumerBarrel2||this.beer.consumerCan||this.beer.consumerBottle) {
                    if(!this.userProfile.willShip&&!this.userProfile.willDeliver&&!this.userProfile.willPickup){
                        this.$bvModal.show("modal-consumershippingerror")
                        return
                    }
                    else{
                        //Set shipping and delivery if exists
                        if(this.userProfile.willShip==1) beerToAdd.willShip = 1
                        else beerToAdd.willShip=0
                        if(this.userProfile.willDeliver==1) beerToAdd.willDeliver = 1
                        else beerToAdd.willDeliver=0
                        if(this.userProfile.willPickup==1) beerToAdd.willPickup = 1
                        else beerToAdd.willPickup=0
                    }
                }

                var hasConsumerCostError = false 
                if (this.beer.consumerBarrel1||this.beer.consumerBarrel2||this.beer.consumerCan||this.beer.consumerBottle) beerToAdd.allowConsumers = 1
                else beerToAdd.allowConsumers = 0
                //If consumers allowed, check prices for consumers

                //Add containers and check costs have been entered
                var hasConsumerCostError = false
                if(this.beer.consumerBarrel1==1){
                    beerToAdd.consumerBarrel1=1
                    beerToAdd.barrel1ConsumerCost = parseFloat(this.beer.barrel1ConsumerCost)
                    if(isNaN(this.beer.barrel1ConsumerCost)) hasConsumerCostError=true

                } 
                else beerToAdd.consumerBarrel1=0

                if(this.beer.consumerBarrel2==1){
                    beerToAdd.consumerBarrel2=1
                    beerToAdd.barrel2ConsumerCost = parseFloat(this.beer.barrel2ConsumerCost)
                    if(isNaN(this.beer.barrel2ConsumerCost)) hasConsumerCostError=true
                } 
                else beerToAdd.consumerBarrel2=0
                
                if(this.beer.consumerCan==1){
                    beerToAdd.consumerCan=1
                    beerToAdd.canConsumerCost = parseFloat(this.beer.canConsumerCost)
                    beerToAdd.canConsumerCaseSize = parseInt(this.beer.canConsumerCaseSize)
                    if(isNaN(this.beer.canConsumerCost)||isNaN(beerToAdd.canConsumerCaseSize)) hasConsumerCostError=true

                } 
                else beerToAdd.consumerCan=0

                if(this.beer.consumerBottle==1){
                    beerToAdd.consumerBottle=1
                    beerToAdd.bottleConsumerCost = parseFloat(this.beer.bottleConsumerCost)
                    beerToAdd.bottleConsumerCaseSize = parseInt(this.beer.bottleConsumerCaseSize)
                    if(isNaN(this.beer.bottleConsumerCost)||isNaN(beerToAdd.bottleConsumerCaseSize)) hasConsumerCostError=true
                } 
                else beerToAdd.consumerBottle=0

                //Show modal if consumer prices were not entered
                if(hasConsumerCostError){
                    this.$bvModal.show("modal-consumercosterror")
                return
                }

                //Check all errors
                console.log("invalidDelivery = " + this.invalidDelivery) 
                console.log("invalidName = " + this.invalidName) 
                console.log("invalidSize = " + this.invalidSize) 
                console.log("invalidBrewer = " + this.invalidBrewer) 
                console.log("invalidCost = " + this.invalidCost) 
                console.log("consumerError = " + hasConsumerCostError) 

                if(this.invalidDelivery||this.invalidName||this.invalidSize||
                this.invalidBrewer||this.invalidCost||hasConsumerCostError){
                    this.showAddBeerError = true
                    this.$bvModal.show("modal-adderror")
                    return
                } 
                else this.showAddBeerError = false  

                
                beerToAdd.type = this.beer.type
                beerToAdd.subType = this.beer.subType
                beerToAdd.abv=this.beer.abv
                beerToAdd.description= this.beer.description
                beerToAdd.cat= this.beer.cat

                //Different collections for distributors and breweries
                var brewerName = ''
                var brewerId = ''
                var distributorName=''
                var distributorId=''
                var fbref = fb.beersCollection

                //BrewerId is always the seller, whethere it's a distributor or brewer
                //distbrewerid tells if this beer is by a distributor. Then distbrewerid is id in distributorbrewers
                if (this.userProfile.isbrewer==1||this.userProfile.isbrewer==10){
                    brewerName = this.userProfile.company
                    //For breweries, beer logo comes from userProfile
                    if(this.userProfile.logoFileThumbnailURL) beerToAdd.logoFileThumbnailURL = this.userProfile.logoFileThumbnailURL
                    else beerToAdd.logoFileThumbnailURL = ""
                } 
                if (this.userProfile.isbrewer==2){
                    brewerName = this.selectedDistroBrewer.company
                    beerToAdd.distbrewerid=this.selectedDistroBrewer.distbrewerid
                    beerToAdd.logoFileThumbnailURL=this.selectedDistroBrewer.logoFileThumbnailURL
                    distributorName = this.userProfile.company
                    distributorId = this.currentUser.uid
                } 

                var createdDate = new Date()
                var createdTime = createdDate.getTime()
                beerToAdd.createdOn = createdDate
                beerToAdd.createdTime = createdTime

                beerToAdd.distributorName = distributorName
                beerToAdd.distributorId = distributorId
                beerToAdd.beerName = this.beer.beerName
                beerToAdd.uid = this.currentUser.uid

                //If rep, use distributorid for uid
                if(this.userProfile.isbrewer==10) beerToAdd.uid=this.userProfile.distributorid
                
                beerToAdd.deliveryMethod = thedeliveryMethod
                beerToAdd.ordersCount = 0
                beerToAdd.brewer = brewerName
                beerToAdd.shortName = this.userProfile.shortName

                var randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
                var randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                beerToAdd.id = randomIdString

                /***********************************/
                //Add locality info
                /***********************************/
                beerToAdd.county=this.userProfile.county
                //Check if distributor, and if the brewery for distributor has counties
                if(this.selectedDistBrewery&&this.selectedDistBrewery.hasOwnProperty('counties')){
                    if(this.selectedDistBrewery.counties.length>0) beerToAdd.counties = this.selectedDistBrewery.counties
                    else beerToAdd.counties = this.userProfile.counties
                }
                else beerToAdd.counties = this.userProfile.counties
                beerToAdd.state = this.userProfile.state
                /***********************************/
                //Add consumer info
                /***********************************/
                if(beerToAdd.allowConsumers==1){
                    beerToAdd.consumerDeliveryTime=this.userProfile.consumerDeliveryTime
                    beerToAdd.consumerDeliveryFees=this.userProfile.consumerDeliveryFees
                    beerToAdd.consumerShippingTime=this.userProfile.consumerShippingTime
                    if(this.userProfile.minForFreeDelivery) beerToAdd.minForFreeDelivery=this.userProfile.minForFreeDelivery
                    else beerToAdd.minForFreeDelivery=999999

                    //Shippping fees
                    if(this.userProfile.case1ShippingSize) beerToAdd.case1ShippingSize = this.userProfile.case1ShippingSize
                    if(this.userProfile.case1ShippingCost) beerToAdd.case1ShippingCost = this.userProfile.case1ShippingCost
                    if(this.userProfile.case2ShippingSize) beerToAdd.case2ShippingSize = this.userProfile.case2ShippingSize
                    if(this.userProfile.case2ShippingCost) beerToAdd.case2ShippingCost = this.userProfile.case2ShippingCost
                    if(this.userProfile.case3ShippingSize) beerToAdd.case3ShippingSize = this.userProfile.case3ShippingSize
                    if(this.userProfile.case3ShippingCost) beerToAdd.case3ShippingCost = this.userProfile.case3ShippingCost
                    if(this.userProfile.case4ShippingSize) beerToAdd.case4ShippingSize = this.userProfile.case4ShippingSize
                    if(this.userProfile.case4ShippingCost) beerToAdd.case4ShippingCost = this.userProfile.case4ShippingCost

                }
                else beerToAdd.allowConsumers='0'
                
                console.log("Adding")
                console.log(beerToAdd)

                fbref.add(beerToAdd).then(() => {
                    this.showSuccess = true
                    this.$bvToast.toast(this.beer.beerName + ' Added to inventory', {
                    title: 'Beer Added!',
                    solid:true,
                    variant: 'success',
                    autoHideDelay: 5000,
                    appendToast: false
                    })

                    if(this.userProfile.isbrewer==1){
                        setTimeout(() => { this.showSuccess = false;
                        this.$router.push({ path: 'inventory'})
                        }, 1500)
                    }
                    if(this.userProfile.isbrewer==2){
                        setTimeout(() => { this.showSuccess = false;
                        this.$router.push({ path: 'distributorinventory'})
                        }, 1500)
                    }
                    
                    this.beer.beerName = ''
                    this.beer.quantity = ''
                    this.beer.abv = ''
                    this.beer.description = ''
                    this.beer.cost=''
                    this.beer.barrel1Size=''
                    this.beer.barrel1Quantity=''
                    this.beer.barrel1Cost=''
                    this.beer.barrel2Size=''
                    this.beer.barrel2Quantity=''
                    this.beer.barrel2Cost=''
                    this.beer.cansPerCase=''
                    this.beer.canQuantity=''
                    this.beer.ozPerCan=''
                    this.beer.ozPerBottle=''
                    this.beer.bottlesPerCase=''
                    this.beer.bottleQuantity=''
                    this.beer.canCost = ''
                    this.beer.bottleCost = ''

                })

            },
            //Check for errors in consumer delivery
            checkConsumerErrors(){
                var hasError = false; this.invalidDeliveryFees=false; this.invalidDeliveryTime=false

                if (this.selectedConsumerDeliveryOptions.length<=0) hasError=true
                if (this.selectedConsumerSizes.length<=0) hasError=true

                return hasError
            },
        },

        mounted(){
            //Check if a brewery name was sent from distributor
            if(Object.keys(this.selectedDistBrewery).length > 0){
                this.setBrewery(this.selectedDistBrewery)
            }
        },
    }
</script>

<style scoped>
    .errorclass{
        color:red;
    }
</style>